
// src/pages/IntradayDollarInfoPage.js
import { useEffect, useState } from 'react';
import { Button, Radio, RadioGroup } from '@blueprintjs/core'; 
import IntradayRecordsTable from '../components/tables/IntradayRecordsTable';
import FirstLeftTable from '../components/tables/FirstLeftTable';
import SecondLeftTable from '../components/tables/SecondLeftTable';
import CandleStickChart from '../components/charts/CandleStickChart';
import AlertasModal from '../components/modales/AlertasModal'; 
import * as con from "./../GlobalConstants";
import { RefRole, RefToken } from '../components/hooks/AuthenticationHook';
import { RefUserAttributesHook } from '../components/hooks/UserAttributesHook';
import { useIntradayData } from '../components/hooks/MarketValuesHook';
import { RefAlertsHook } from '../components/hooks/TransactionsHooks';


const calculateFontSize = (width) => {
  if (width <= 1480) return '4';
  if (width <= 1920) return '10px';
  return '12px';
};


function IntradayDollarInfoPage() {
      
  const [fontSize, setFontSize] = useState('12px');
  const [selectedPage, setSelectedPage] = useState('resumen');
  const [isModalOpen, setIsModalOpen] = useState(false);

  const user = RefUserAttributesHook('user');
  const token = RefToken();
  const role = RefRole;        
  useEffect(() => {
    const adjustStyles = () => {
      const width = window.innerWidth;
      setFontSize(calculateFontSize(width));
    };
    adjustStyles();
    window.addEventListener('resize', adjustStyles);
    return () => {
      window.removeEventListener('resize', adjustStyles);
    };
  }, []);

  const { data, loading, refetch } = useIntradayData();
  const alerts = RefAlertsHook()


  const handleOpenModal = () => {   
    setIsModalOpen(true);
  };
  const handleCloseModal = () => {
    setIsModalOpen(false);
  };

  if (loading) {
    return <div>Cargando...</div>;
  }
  if (!data) {
    return <div>No se pudo cargar la información intradía del dólar.</div>;
  }

  const isMarketClosed = data.market_status === 'closed';
  const isNotViewer = role !== con.VIEWER;  

  return (
     <div
      style={{
          position: 'absolute',
          top: '18.5vh',
          left: 0,
          right: 0,
          height: '78.5vh',
          display: 'flex',
          flexDirection: 'column',
          padding: '20px',
          boxSizing: 'border-box',
          overflow: 'hidden'
        }}
      >

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '10px', gap: '120px' }}>
        <Button 
          text="Actualizar" 
          onClick={refetch} 
        />
        {isNotViewer && (    
          <Button 
            text="Alertas" 
            icon="notifications" 
            onClick={handleOpenModal} 
            disabled={!user || !token}
          />
        )}
      </div>

      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '20px' }}>
        <RadioGroup
          inline
          selectedValue={selectedPage}
          onChange={(e) => setSelectedPage(e.currentTarget.value)}
        >
          <Radio value="resumen" label="Resumen del dólar actual" />
          <Radio value="cotizaciones" label="Cotizaciones intraday" />
        </RadioGroup>
      </div>


      {selectedPage === 'resumen' && (
        <div
          style={{
            flex: 1,
            display: 'flex',
            width: '100%',
            gap: '15px',
          }}
        >

          <div style={{ 
            flex: '0 0 65%'          
          }}>
            <CandleStickChart 
              data={data.intraday_data} 
              alerts={alerts}
              style={{ height: '100%', width: '100%' }}
            />
          </div>
          
          <div style={{ 
            flex: '0 0 35%',
            display: 'flex',
            flexDirection: 'column',
            gap: '15px',
          }}>
            {isMarketClosed && (
              <div 
                style={{ 
                  backgroundColor: 'rgba(255, 0, 0, 0.8)',
                  color: 'white',
                  padding: '8px 12px',
                  borderRadius: '5px',
                  textAlign: 'center',
                  alignSelf: 'center',
                  width: 'fit-content'
                }}
              >
                El mercado está cerrado
              </div>
            )}

            <div>
              <FirstLeftTable 
                data={data} 
                fontSize={fontSize}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <SecondLeftTable 
                data={data} 
                fontSize={fontSize}
                style={{ height: '100%', width: '100%' }}
              />
            </div>
          </div>
        </div>
      )}

      {selectedPage === 'cotizaciones' && (
        <div
        style={{
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          minHeight: 0
        }}
        >
          {data.intraday_data ? (
            <IntradayRecordsTable data={data.intraday_data} />
          ) : (
            <div>No hay datos intradía disponibles.</div>
          )}
        </div>
      )}

      <AlertasModal
        isOpen={isModalOpen}
        handleClose={handleCloseModal}
      />
    </div>
  );
}

export default IntradayDollarInfoPage;